module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Medium-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Medium-webfont.svg
// module id = 1636
// module chunks = 0